/* ==========================================================================
   BlendUp — comportement du thème
   Vanilla JS, sans dépendance. Aucun prix n'est inventé côté client :
   le panier affiche toujours les montants renvoyés par Shopify.
   ========================================================================== */
(function () {
  'use strict';

  var BU = (window.BlendUp = window.BlendUp || {});
  var cfg = BU.config || {};
  var t = cfg.strings || {};

  /* ---------- Utilitaires --------------------------------------------------- */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function money(cents) {
    var format = cfg.moneyFormat || '{{amount_with_comma_separator}} €';
    var value = (cents || 0) / 100;
    function withDelims(number, precision, thousands, decimal) {
      var parts = Math.abs(number).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var out = whole + (parts[1] ? decimal + parts[1] : '');
      return (number < 0 ? '-' : '') + out;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return withDelims(value, 2, ',', '.');
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_space_separator': return withDelims(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return withDelims(value, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return withDelims(value, 2, "'", '.');
        default: return withDelims(value, 2, ' ', ',');
      }
    });
  }
  BU.money = money;

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent('blendup:' + name, { detail: detail || {}, bubbles: true }));
  }
  BU.emit = emit;

  function request(url, options) {
    return fetch(url, Object.assign({
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin'
    }, options || {})).then(function (res) {
      return res.json().then(function (body) {
        if (!res.ok) { throw Object.assign(new Error(body.description || body.message || 'error'), { body: body }); }
        return body;
      });
    });
  }

  /* ---------- Toast --------------------------------------------------------- */

  var toastEl, toastTimer;
  function toast(message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'bu-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3200);
  }
  BU.toast = toast;

  /* ---------- Reveal au scroll --------------------------------------------- */

  function initReveal() {
    var items = $$('.bu-reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Header / navigation mobile ------------------------------------ */

  function initHeader() {
    var burger = $('[data-bu-burger]');
    var nav = $('[data-bu-mobile-nav]');
    if (!burger || !nav) return;
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('bu-no-scroll', open);
    });
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) {
        nav.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('bu-no-scroll');
      }
    });
  }

  /* ---------- FAQ ----------------------------------------------------------- */

  function initFaq() {
    $$('[data-bu-faq]').forEach(function (root) {
      var single = root.hasAttribute('data-single-open');
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('.bu-faq__q');
        if (!btn) return;
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        var open = btn.getAttribute('aria-expanded') === 'true';
        if (single && !open) {
          $$('.bu-faq__q[aria-expanded="true"]', root).forEach(function (other) {
            other.setAttribute('aria-expanded', 'false');
            document.getElementById(other.getAttribute('aria-controls')).hidden = true;
          });
        }
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) panel.hidden = open;
      });
    });
  }

  /* ---------- Vidéo --------------------------------------------------------- */

  function initVideo() {
    $$('[data-bu-video]').forEach(function (root) {
      var video = $('video', root);
      var toggle = $('[data-bu-video-toggle]', root);
      if (!video || !toggle) return;
      function sync() {
        var playing = !video.paused;
        toggle.setAttribute('aria-label', playing ? (t.pause || 'Pause') : (t.play || 'Lecture'));
        toggle.dataset.state = playing ? 'playing' : 'paused';
      }
      toggle.addEventListener('click', function () {
        if (video.paused) { video.play(); } else { video.pause(); }
        sync();
      });
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      sync();
    });
  }

  /* ---------- Panier -------------------------------------------------------- */

  var Cart = BU.cart = {
    state: null,

    open: function () {
      var drawer = $('[data-bu-drawer]');
      var overlay = $('[data-bu-overlay]');
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.removeAttribute('aria-hidden');
      if (overlay) overlay.classList.add('is-open');
      document.body.classList.add('bu-no-scroll');
      var close = $('[data-bu-drawer-close]', drawer);
      if (close) close.focus();
      emit('cart:opened', { cart: Cart.state });
    },

    close: function () {
      var drawer = $('[data-bu-drawer]');
      var overlay = $('[data-bu-overlay]');
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('is-open');
      document.body.classList.remove('bu-no-scroll');
    },

    fetch: function () {
      return request(cfg.routes.cart + '.js').then(function (cart) {
        Cart.state = cart;
        Cart.render(cart);
        return cart;
      });
    },

    add: function (items) {
      return request(cfg.routes.cartAdd + '.js', {
        method: 'POST',
        body: JSON.stringify({ items: items })
      }).then(function () {
        return Cart.fetch();
      });
    },

    change: function (line, quantity) {
      var drawer = $('[data-bu-drawer]');
      if (drawer) drawer.classList.add('is-busy');
      return request(cfg.routes.cartChange + '.js', {
        method: 'POST',
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function (cart) {
        Cart.state = cart;
        Cart.render(cart);
        emit('cart:updated', { cart: cart });
        return cart;
      }).catch(function () {
        toast(t.cartError || 'Le panier n’a pas pu être mis à jour.');
      }).finally(function () {
        if (drawer) drawer.classList.remove('is-busy');
      });
    },

    render: function (cart) {
      Cart.renderCount(cart.item_count);
      var body = $('[data-bu-drawer-body]');
      var foot = $('[data-bu-drawer-foot]');
      if (!body) return;

      if (!cart.item_count) {
        body.innerHTML =
          '<div class="bu-drawer__empty">' +
            '<p>' + esc(t.cartEmpty || 'Ton panier est vide.') + '</p>' +
            '<a class="bu-btn bu-btn--ink" href="' + esc(cfg.routes.allProducts || '/collections/all') + '">' +
              esc(t.cartEmptyCta || 'Découvrir BlendUp') +
            '</a>' +
          '</div>';
        if (foot) foot.hidden = true;
        return;
      }
      if (foot) foot.hidden = false;

      body.innerHTML = cart.items.map(function (item, index) {
        var line = index + 1;
        var discounted = item.original_line_price > item.final_line_price;
        var chip = item.options_with_values && item.options_with_values.length
          ? colorChipFor(item.options_with_values[0].value)
          : '';
        var discountHtml = (item.line_level_discount_allocations || []).map(function (d) {
          return '<div class="bu-line__discount">' + esc(d.discount_application.title) +
                 ' · −' + money(d.amount) + '</div>';
        }).join('');

        return '' +
          '<div class="bu-line" data-line="' + line + '">' +
            '<div class="bu-line__img">' +
              (item.image ? '<img src="' + esc(item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')) + '" alt="" width="68" height="68" loading="lazy">' : '') +
            '</div>' +
            '<div>' +
              '<div class="bu-line__name">' + esc(item.product_title) + '</div>' +
              (item.variant_title ? '<div class="bu-line__variant">' + chip + esc(colorLabel(item.variant_title)) + '</div>' : '') +
              discountHtml +
              '<div class="bu-line__bottom">' +
                '<div class="bu-qty">' +
                  '<button type="button" data-bu-qty="' + line + '" data-to="' + (item.quantity - 1) + '" aria-label="' + esc(t.decrease || 'Retirer une unité') + '">' + icon('minus') + '</button>' +
                  '<output>' + item.quantity + '</output>' +
                  '<button type="button" data-bu-qty="' + line + '" data-to="' + (item.quantity + 1) + '" aria-label="' + esc(t.increase || 'Ajouter une unité') + '">' + icon('plus') + '</button>' +
                '</div>' +
                '<div class="bu-line__price">' +
                  (discounted ? '<s>' + money(item.original_line_price) + '</s>' : '') +
                  money(item.final_line_price) +
                '</div>' +
              '</div>' +
            '</div>' +
          '</div>';
      }).join('');

      var upsell = $('[data-bu-upsell]');
      if (upsell) {
        var threshold = parseInt(upsell.dataset.buUpsell, 10) || 0;
        upsell.hidden = !(threshold && cart.item_count > 0 && cart.item_count < threshold);
      }

      var saved = cart.original_total_price - cart.total_price;
      var savedRow = $('[data-bu-saved]');
      if (savedRow) {
        savedRow.hidden = saved <= 0;
        var savedVal = $('[data-bu-saved-value]', savedRow);
        if (savedVal) savedVal.textContent = '−' + money(saved);
      }
      var subtotal = $('[data-bu-subtotal]');
      if (subtotal) subtotal.textContent = money(cart.total_price);
      var origin = $('[data-bu-original]');
      if (origin) {
        origin.hidden = saved <= 0;
        var originVal = $('[data-bu-original-value]', origin);
        if (originVal) originVal.textContent = money(cart.original_total_price);
      }
    },

    renderCount: function (count) {
      $$('[data-bu-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = !count;
      });
    }
  };

  function colorLabel(value) {
    var map = cfg.colorLabels || {};
    var key = String(value).trim().toLowerCase();
    return map[key] || value;
  }

  function colorChipFor(value) {
    var map = cfg.colorHex || {};
    var hex = map[String(value).trim().toLowerCase()];
    return hex ? '<span class="bu-line__chip" style="background:' + esc(hex) + '"></span>' : '';
  }

  function icon(name) {
    var paths = {
      minus: '<path d="M5 12h14"/>',
      plus: '<path d="M12 5v14M5 12h14"/>'
    };
    return '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">' + (paths[name] || '') + '</svg>';
  }

  function initCart() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-bu-cart-open]')) {
        e.preventDefault();
        Cart.fetch().then(Cart.open);
        return;
      }
      if (e.target.closest('[data-bu-drawer-close]') || e.target.closest('[data-bu-overlay]')) {
        Cart.close();
        return;
      }
      var qtyBtn = e.target.closest('[data-bu-qty]');
      if (qtyBtn) {
        Cart.change(parseInt(qtyBtn.dataset.buQty, 10), parseInt(qtyBtn.dataset.to, 10));
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') Cart.close();
    });

    var drawer = $('[data-bu-drawer]');
    if (drawer) {
      drawer.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var focusables = $$('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])', drawer)
          .filter(function (el) { return el.offsetParent !== null; });
        if (!focusables.length) return;
        var first = focusables[0], last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }

    Cart.fetch().catch(function () { /* le panier reste au rendu serveur */ });
  }

  /* ---------- Sélecteur de pack + couleurs ---------------------------------- */

  function initProduct() {
    var root = $('[data-bu-product]');
    if (!root) return;

    var variants = JSON.parse(root.dataset.buVariants || '[]');
    var packs = JSON.parse(root.dataset.buPacks || '[]');
    var unitPrice = parseInt(root.dataset.buUnitPrice, 10) || 0;

    var state = {
      pack: packs.length ? packs[0].quantity : 1,
      colors: []
    };

    // Un premier choix pré-rempli avec la variante affichée : la couleur de
    // l'unité 1 est déjà connue, autant ne pas la redemander.
    var initial = variants.filter(function (v) { return v.available; })[0];
    if (initial) state.colors[0] = initial.id;

    var unitsEl = $('[data-bu-units]', root);
    var errorEl = $('[data-bu-error]', root);
    var atcBtn = $('[data-bu-atc]', root);
    var priceEl = $('[data-bu-price]', root);

    function packConfig(qty) {
      return packs.filter(function (p) { return p.quantity === qty; })[0] || { quantity: qty };
    }

    function variantById(id) {
      return variants.filter(function (v) { return v.id === id; })[0];
    }

    /* Prix affiché : le prix pack n'apparaît que si le marchand l'a renseigné,
       sinon on montre simplement le total au prix unitaire. */
    function displayedTotal() {
      var p = packConfig(state.pack);
      var base = unitPrice * state.pack;
      if (p.price && p.price > 0) {
        return { total: p.price, base: base, saving: Math.max(0, base - p.price) };
      }
      return { total: base, base: base, saving: 0 };
    }

    function renderUnits() {
      if (!unitsEl) return;
      var html = '';
      for (var i = 0; i < state.pack; i++) {
        var chosen = state.colors[i];
        html += '<div class="bu-unit" data-unit="' + i + '">' +
          '<div class="bu-unit__title" id="bu-unit-' + i + '">' +
            (state.pack === 1
              ? esc(t.chooseColor || 'Choisis ta couleur')
              : esc((t.unit || 'BlendUp n°') + (i + 1))) +
          '</div>' +
          '<div class="bu-swatches" role="group" aria-labelledby="bu-unit-' + i + '">' +
            variants.map(function (v) {
              var selected = chosen === v.id;
              return '<button type="button" class="bu-swatch" data-bu-swatch="' + i + '" data-variant="' + v.id + '"' +
                ' aria-pressed="' + (selected ? 'true' : 'false') + '"' +
                (v.available ? '' : ' disabled') + '>' +
                '<span class="bu-swatch__chip" style="background:' + esc(v.hex || '#ddd') + '"></span>' +
                '<span>' + esc(v.label) + '</span>' +
              '</button>';
            }).join('') +
          '</div>' +
        '</div>';
      }
      unitsEl.innerHTML = html;
    }

    function renderPrice() {
      if (!priceEl) return;
      var d = displayedTotal();
      var html = '<span class="bu-price__now">' + money(d.total) + '</span>';
      if (d.saving > 0) {
        html += '<span class="bu-price__was">' + money(d.base) + '</span>';
        html += '<span class="bu-badge bu-badge--save">' + esc(t.save || 'Économie') + ' ' + money(d.saving) + '</span>';
      }
      if (state.pack > 1) {
        html += '<span class="bu-price__unit">' + money(Math.round(d.total / state.pack)) + ' ' + esc(t.perUnit || 'par BlendUp') + '</span>';
      }
      priceEl.innerHTML = html;
    }

    function renderCta() {
      var d = displayedTotal();
      var label = (state.pack > 1 ? (t.addPack || 'Ajouter le pack') : (t.addToCart || 'Ajouter au panier')) + ' — ' + money(d.total);
      if (atcBtn) atcBtn.textContent = label;
      var stickyName = $('[data-bu-sticky-name]');
      var stickyPrice = $('[data-bu-sticky-price]');
      if (stickyName) stickyName.textContent = packConfig(state.pack).name || root.dataset.buTitle || '';
      if (stickyPrice) stickyPrice.textContent = money(d.total);
    }

    function renderPacks() {
      $$('[data-bu-pack]', root).forEach(function (el) {
        var qty = parseInt(el.dataset.buPack, 10);
        var on = qty === state.pack;
        el.classList.toggle('is-selected', on);
        var input = $('input', el);
        if (input) input.checked = on;
      });
    }

    function clearError() {
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      $$('.bu-unit', unitsEl).forEach(function (u) { u.classList.remove('has-error'); });
    }

    function showError(message, unitIndex) {
      if (errorEl) {
        errorEl.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 8v4.5M12 16h.01"/></svg><span>' + esc(message) + '</span>';
        errorEl.hidden = false;
      }
      if (unitIndex != null) {
        var unit = $('.bu-unit[data-unit="' + unitIndex + '"]', unitsEl);
        if (unit) {
          unit.classList.add('has-error');
          unit.scrollIntoView({ block: 'center', behavior: 'smooth' });
          var firstSwatch = $('.bu-swatch:not([disabled])', unit);
          if (firstSwatch) firstSwatch.focus();
        }
      }
    }

    function setPack(qty) {
      state.pack = qty;
      state.colors = state.colors.slice(0, qty);
      clearError();
      renderPacks();
      renderUnits();
      renderPrice();
      renderCta();
      emit('select_bundle', { quantity: qty });
    }

    function setColor(unitIndex, variantId) {
      state.colors[unitIndex] = variantId;
      clearError();
      renderUnits();
      var v = variantById(variantId);
      if (v && v.image) {
        var main = $('[data-bu-gallery-main] img');
        if (main) { main.src = v.image; main.removeAttribute('srcset'); }
      }
      emit('select_color', { unit: unitIndex + 1, variantId: variantId });
    }

    function missingUnit() {
      for (var i = 0; i < state.pack; i++) {
        if (!state.colors[i]) return i;
      }
      return -1;
    }

    function addToCart() {
      var missing = missingUnit();
      if (missing !== -1) {
        var label = state.pack === 1
          ? (t.errorColorSingle || 'Choisis la couleur de ton BlendUp.')
          : (t.errorColor || 'Choisis la couleur de ton BlendUp n°{n}.').replace('{n}', missing + 1);
        showError(label, missing);
        return;
      }

      // Regroupement : deux unités de la même couleur forment une seule ligne
      // de quantité 2. La couleur reste portée par la variante, donc rien ne
      // se perd entre le panier, la commande et la préparation.
      var grouped = {};
      state.colors.slice(0, state.pack).forEach(function (id) {
        grouped[id] = (grouped[id] || 0) + 1;
      });
      var items = Object.keys(grouped).map(function (id) {
        return { id: parseInt(id, 10), quantity: grouped[id] };
      });

      if (atcBtn) { atcBtn.classList.add('is-loading'); atcBtn.disabled = true; }

      Cart.add(items).then(function (cart) {
        emit('add_to_cart', { items: items, cart: cart });
        Cart.open();
      }).catch(function (err) {
        showError((err && err.body && err.body.description) || (t.cartError || 'L’ajout au panier a échoué. Réessaie.'));
      }).finally(function () {
        if (atcBtn) { atcBtn.classList.remove('is-loading'); atcBtn.disabled = false; }
      });
    }

    root.addEventListener('click', function (e) {
      var pack = e.target.closest('[data-bu-pack]');
      if (pack) { setPack(parseInt(pack.dataset.buPack, 10)); return; }

      var swatch = e.target.closest('[data-bu-swatch]');
      if (swatch && !swatch.disabled) {
        setColor(parseInt(swatch.dataset.buSwatch, 10), parseInt(swatch.dataset.variant, 10));
        return;
      }

      if (e.target.closest('[data-bu-atc]')) { e.preventDefault(); addToCart(); }
    });

    root.addEventListener('keydown', function (e) {
      var pack = e.target.closest('[data-bu-pack]');
      if (pack && (e.key === ' ' || e.key === 'Enter')) {
        e.preventDefault();
        setPack(parseInt(pack.dataset.buPack, 10));
      }
    });

    // Galerie
    var thumbs = $$('[data-bu-thumb]', root);
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var main = $('[data-bu-gallery-main] img');
        if (main) { main.src = thumb.dataset.full; main.removeAttribute('srcset'); }
        thumbs.forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });

    // Le sticky reprend le CTA principal une fois celui-ci passé
    var sticky = $('[data-bu-sticky]');
    if (sticky && atcBtn) {
      $('[data-bu-sticky-atc]', sticky).addEventListener('click', function () {
        addToCart();
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
        }, { threshold: 0 }).observe(atcBtn);
      }
    }

    setPack(state.pack);
  }

  /* ---------- Upsell panier ------------------------------------------------- */

  function initUpsell() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bu-upsell-add]');
      if (!btn) return;
      e.preventDefault();
      var id = parseInt(btn.dataset.buUpsellAdd, 10);
      if (!id) return;
      btn.classList.add('is-loading');
      Cart.add([{ id: id, quantity: 1 }]).then(function () {
        toast(t.upsellDone || 'Ajouté au panier.');
      }).catch(function () {
        toast(t.cartError || 'L’ajout au panier a échoué.');
      }).finally(function () {
        btn.classList.remove('is-loading');
      });
    });
  }


  /* ---------- Compte à rebours (uniquement sur une date réelle) ------------- */

  function initCountdown() {
    $$('[data-bu-countdown]').forEach(function (el) {
      var raw = el.dataset.buCountdown;
      var end = new Date(raw.replace(' ', 'T'));
      if (isNaN(end.getTime())) return;

      var d = $('[data-cd-d]', el), h = $('[data-cd-h]', el),
          m = $('[data-cd-m]', el), sec = $('[data-cd-s]', el);

      function pad(n) { return n < 10 ? '0' + n : String(n); }

      function tick() {
        var left = end.getTime() - Date.now();
        // L'offre est terminée : le bloc disparaît. Il ne se réinitialise jamais.
        if (left <= 0) {
          el.hidden = true;
          clearInterval(timer);
          return;
        }
        el.hidden = false;
        var s1 = Math.floor(left / 1000);
        d.textContent = Math.floor(s1 / 86400);
        h.textContent = pad(Math.floor(s1 % 86400 / 3600));
        m.textContent = pad(Math.floor(s1 % 3600 / 60));
        sec.textContent = pad(s1 % 60);
      }

      tick();
      var timer = setInterval(tick, 1000);
    });
  }

  /* ---------- Recettes ------------------------------------------------------ */

  function initRecipes() {
    $$('[data-bu-recipes]').forEach(function (root) {
      var tabs = $$('[data-bu-recipe-tab]', root);
      var cards = $$('[data-bu-recipe]', root);
      if (!tabs.length) return;

      function apply(filter) {
        tabs.forEach(function (tab) {
          tab.setAttribute('aria-selected', tab.dataset.buRecipeTab === filter ? 'true' : 'false');
        });
        cards.forEach(function (card) {
          card.hidden = !(filter === 'all' || card.dataset.buRecipe === filter);
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { apply(tab.dataset.buRecipeTab); });
      });

      apply(tabs[0].dataset.buRecipeTab);
    });
  }


  /* ---------- Barre d'annonce défilante ------------------------------------ */

  function initAnnouncement() {
    $$('[data-bu-announce]').forEach(function (bar) {
      var slides = $$('[data-bu-slide]', bar);
      var dots = $$('[data-bu-dot]', bar);
      if (slides.length < 2) return;

      var interval = parseInt(bar.dataset.interval, 10) || 5000;
      var index = 0;
      var timer = null;

      function show(next) {
        slides[index].classList.remove('is-active');
        slides[index].setAttribute('aria-hidden', 'true');
        if (dots[index]) dots[index].setAttribute('aria-selected', 'false');
        index = (next + slides.length) % slides.length;
        slides[index].classList.add('is-active');
        slides[index].removeAttribute('aria-hidden');
        if (dots[index]) dots[index].setAttribute('aria-selected', 'true');
      }

      function start() { stop(); timer = setInterval(function () { show(index + 1); }, interval); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          show(parseInt(dot.dataset.buDot, 10));
          start();
        });
      });

      // On n'anime pas dans le vide : la rotation s'arrête au survol, au focus
      // clavier et dès que l'onglet passe en arrière-plan.
      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', start);
      bar.addEventListener('focusin', stop);
      bar.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { stop(); } else { start(); }
      });

      start();
    });
  }

  /* ---------- Démarrage ----------------------------------------------------- */

  function boot() {
    initReveal();
    initHeader();
    initFaq();
    initVideo();
    initCart();
    initProduct();
    initUpsell();
    initCountdown();
    initRecipes();
    initAnnouncement();
    emit('page_view', { path: location.pathname });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
